/**
 * Reader preferences type and defaults.
 * Extracted to a separate file to satisfy react-refresh fast-refresh rules.
 */
export interface ReaderPrefs {
  fontFamily: "sans" | "serif" | "mono";
  fontSize: "sm" | "base" | "lg" | "xl";
  columnWidth: "prose" | "wide" | "full";
}

export const DEFAULT_READER_PREFS: ReaderPrefs = {
  fontFamily: "sans",
  fontSize: "base",
  columnWidth: "prose",
};
